import {useState} from 'react'
import {getUserCollaborator} from '../services'
import {UseCollaboratorFilterModel, SelectModel} from '../model'
const useCollaboratorList = () => {
  const [loading, setLoading] = useState(false)
  const [collaborator, setCollaborator] = useState<SelectModel[]>([])

  const getUserCollaboratorAPI = async (collaboratorParms: UseCollaboratorFilterModel) => {
    let obj: UseCollaboratorFilterModel = {
      ...collaboratorParms,
    }
    return await getUserCollaborator(obj)
  }

  const getUserCollaboratorData = async (collaboratorParms: UseCollaboratorFilterModel) => {
    setLoading(true)
    try {
      const response = await getUserCollaboratorAPI(collaboratorParms)
      return response.data.data
    } catch (error) {
      console.error('Error fetching service data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }
  const mapDataSelect = (data: any[], value: string = '', label: string = '') => {
    if (value === '') {
      return data.map((item) => ({
        value: item.usuarioId,
        label: `${item.paterno} ${item.materno} ${item.nombres} (${item.tipoDocumentoNombre} ${item.numeroDocumento})`,
        ...item,
      }))
    } else {
      return data.map((item) => ({
        value: item[value],
        label: item[label],
        ...item,
      }))
    }
  }

  const updateCollaboratorList = (mappedSites: {value: string; label: string}[]) => {
    setCollaborator(mappedSites)
  }

  const getUserCollaboratorList = async (
    collaboratorParms: UseCollaboratorFilterModel = {},
    value: string = '',
    label: string = '',
  ) => {
    try {
      const data = await getUserCollaboratorData(collaboratorParms)
      const mappedSites = mapDataSelect(data, value, label)
      updateCollaboratorList(mappedSites)
    } catch (error) {
      console.error('Error fetching service data:', error)
    }
  }

  const handleClear = () => {
    setCollaborator([])
  }

  return {
    loading,
    collaborator,
    getUserCollaboratorList,
    handleClear,
    getUserCollaboratorData,
  }
}

export default useCollaboratorList
